import type { TPostponedDealsSortField } from '@crm/entities/deal';

export const DEALS_TABLE_LIMIT_OPTIONS = {
    headerHeight: 40,
    maxLimit: 100,
    rowGap: 4,
    rowHeight: 40,
};

export const DEALS_TABLE_SORT_FIELDS = {
    postponedUntil: 'postponed_until',
} as const satisfies Record<string, TPostponedDealsSortField>;

export const DEALS_TABLE_ALLOW_SORT_CLEAR = Object.keys(DEALS_TABLE_SORT_FIELDS).length > 1;

export const SEARCH_QUERY_PARAM = 'query';
